// Fenêtre « Renommer un client partout » : ce que le renommage touche, en phrases courtes.
const MONTH_NAMES = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

function dayLabel(isoDate, withMonth = true) {
  const [, month, day] = String(isoDate).split("-").map(Number);
  const label = day === 1 ? "1er" : String(day);
  return withMonth ? `${label} ${MONTH_NAMES[month - 1] || ""}`.trim() : label;
}

// « 16 octobre », « 14 au 19 octobre », « 30 septembre au 2 octobre ».
function formatDateRange(isoDates) {
  if (!isoDates.length) return "";
  const first = String(isoDates[0]);
  const last = String(isoDates[isoDates.length - 1]);
  if (first === last) return dayLabel(first);
  return `${dayLabel(first, first.slice(0, 7) !== last.slice(0, 7))} au ${dayLabel(last)}`;
}

export function buildClientRenameImpactItems(preview) {
  const renamed = Number(preview?.orders_to_rename) || 0;
  const kept = Number(preview?.orders_kept) || 0;
  const range = formatDateRange(Array.isArray(preview?.open_dates) ? preview.open_dates : []);
  const dates = range ? ` (${range})` : "";
  return [
    ...(renamed === 1 ? [`1 commande ouverte${dates} et sa tournée prennent le nouveau nom.`] : []),
    ...(renamed > 1 ? [`${renamed} commandes ouvertes${dates} et leurs tournées prennent le nouveau nom.`] : []),
    ...(kept === 1 ? ["1 commande d’une journée clôturée garde l’ancien."] : []),
    ...(kept > 1 ? [`Les ${kept} commandes des journées clôturées gardent l’ancien.`] : []),
    "L’ancien nom reste reconnu : imports, rapports, journées clôturées.",
  ];
}

export function isClientInUse(preview) {
  return Number(preview?.orders_to_rename) > 0 || Number(preview?.orders_kept) > 0;
}
